export default [
  {
    path: "/",
    name: "index",
    meta: {
      title: "巨能宝年卡",
      indexStyle: "style1",
      textKey: "486",
    },
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/index.vue"),
  },
  {
    path: "/success",
    name: "success",
    meta: {
      title: "巨能宝年卡-订购成功页",
      indexStyle: "style1",
    },
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/success.vue"),
  }
];
